// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-FrB","label":"styles_label__10gmw"};